module.exports = __webpack_public_path__ + "img/key.4f725f2a.svg";